/* eslint-disable no-undef */
import { logDebugging } from '../../../log/logger';
import AdException from '../../errors/ad.exception';
import JsTagDisplay from '../../jstag/display';
import DisplayPlayerController from './display.player.controller';

export default class DisplayPlayerManager {
  constructor(idComponent, cid, itemContent) {
    this.idComponent = idComponent;
    this.itemContent = itemContent;
    this.cid = cid;
    this.controllerComponent = new DisplayPlayerController(this.itemContent, this.cid);
  }

  async load(adunit) {
    this.adunit = adunit;

    this.createAdContainer();

    const jstagdisplay = new JsTagDisplay(this.itemContent);
    const resultDisplay = await jstagdisplay.call(this.adunit);
    return new Promise((resolve, reject) => {
      if (resultDisplay.ad) {
        this.controllerComponent.insert(resultDisplay.code);
        logDebugging('[DisplayPlayerManager]', resultDisplay);
        resolve(this.controllerComponent);
      } else {
        reject(new AdException('No display ad returned', '011'));
      }
    });
  }

  createAdContainer() {
    const idAdContainer = this.adunit.divId;
    if (document.getElementById(idAdContainer)) return;

    const cont =
      document
        .getElementById(this.idComponent)
        .querySelector('#video-ext-container>.tpx-ext-control-bar') ||
      document.getElementById(this.idComponent);

    const adContainer = document.createElement('div');
    adContainer.id = idAdContainer; // 'adContainer'

    if (cont) cont.appendChild(adContainer);
  }

  getEvent() {
    return this.controllerComponent.getEvent();
  }
}
